import { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, onSnapshot, addDoc, query, orderBy } from "firebase/firestore";

export function useLista(nomeCollezione) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, nomeCollezione), orderBy("nome"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setItems(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      setLoading(false);
    });
    return unsubscribe;
  }, [nomeCollezione]);

  async function aggiungiItem(nome, extraData = {}) {
    await addDoc(collection(db, nomeCollezione), { nome, ...extraData });
  }

  return { items, loading, aggiungiItem };
}